var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-dialog-confirm',_vm._b({ref:"confirmDialog",attrs:{"loading":_vm.loading},on:{"click-anchor":_vm.ok}},'base-dialog-confirm',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }